import { parseParams } from '@crossroads/location-search-string';
import { updateData, EFFECT_ERROR } from 'crustate';

function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}

var _excluded = ["sortOrder", "sort", "page"];
var DEFAULT_SORT = {
  order: "DESC",
  code: ""
};
var endsWith = function endsWith(str, match) {
  if (typeof str !== "string") {
    return false;
  }
  if (str.length <= match.length) {
    return false;
  }
  return str.slice(-match.length) === match;
};
var getInputFilters = function getInputFilters(location, incVat, pointsToPrice) {
  if (incVat === void 0) {
    incVat = true;
  }
  if (pointsToPrice === void 0) {
    pointsToPrice = function pointsToPrice(value) {
      return value;
    };
  }
  /* eslint-disable no-unused-vars */
  var _parseParams = parseParams(location.search),
    sortOrder = _parseParams.sortOrder,
    sort = _parseParams.sort,
    page = _parseParams.page,
    rest = _objectWithoutPropertiesLoose(_parseParams, _excluded);
  /* eslint-enable no-unused-vars */

  var filters = Object.keys(rest).reduce(function (acc, curr) {
    if (curr.startsWith("filter_")) {
      acc[curr.substring(7)] = rest[curr];
    }
    return acc;
  }, {});
  var ranges = Object.keys(filters).filter(function (x) {
    return endsWith(x, "_min") || endsWith(x, "_max");
  }).reduce(function (acc, key) {
    var paramName = key.slice(0, -4);
    var label = key.slice(-4) === "_min" ? "min" : "max";
    if (!acc[paramName]) {
      acc[paramName] = {};
    }
    acc[paramName][label] = parseFloat(filters[key]);
    return acc;
  }, {});
  var rangeFilters = Object.keys(ranges).reduce(function (acc, key) {
    var filter = {
      code: key
    };
    if (key === "price" || key.startsWith("points:")) {
      filter = _extends({}, filter, {
        incVat: incVat
      });
      if (!isNaN(ranges[key].min)) {
        filter = _extends({}, filter, {
          minValue: key === "price" ? pointsToPrice(ranges[key].min) : ranges[key].min
        });
      }
      if (!isNaN(ranges[key].max)) {
        filter = _extends({}, filter, {
          maxValue: key === "price" ? pointsToPrice(ranges[key].max) : ranges[key].max
        });
      }
    } else {
      if (!isNaN(ranges[key].min)) {
        filter = _extends({}, filter, {
          minValue: ranges[key].min
        });
      }
      if (!isNaN(ranges[key].max)) {
        filter = _extends({}, filter, {
          maxValue: ranges[key].max
        });
      }
    }
    return [].concat(acc, [filter]);
  }, []);
  var valueFilters = Object.keys(filters).filter(function (x) {
    return !(endsWith(x, "_min") || endsWith(x, "_max"));
  }).reduce(function (acc, key) {
    return [].concat(acc, [{
      code: key,
      value: filters[key]
    }]);
  }, []);
  return [].concat(rangeFilters, valueFilters);
};
var getInputSort = function getInputSort(location, defaultSort) {
  if (defaultSort === void 0) {
    defaultSort = DEFAULT_SORT;
  }
  var _parseParams2 = parseParams(location.search),
    _parseParams2$sortOrd = _parseParams2.sortOrder,
    sortOrder = _parseParams2$sortOrd === void 0 ? defaultSort.order : _parseParams2$sortOrd,
    _parseParams2$sort = _parseParams2.sort,
    sort = _parseParams2$sort === void 0 ? defaultSort.code : _parseParams2$sort;
  if (sortOrder !== "ASC" && sortOrder !== "DESC" || typeof sort !== "string" || sort === "") {
    return null;
  }
  return {
    order: sortOrder,
    code: sort
  };
};
var getPage = function getPage(location) {
  var page = parseInt(parseParams(location.search).page, 10);
  return page > 0 ? page : null;
};

/* eslint-disable unicorn/import-index */
var SEARCH_RESPONSE = "response/search";
var SEARCH_REQUEST = "request/search";
var search = function search(query, location, incVat, pointsToPrice) {
  var filters = getInputFilters(location, incVat, pointsToPrice);
  var sort = getInputSort(location);
  var page = getPage(location);
  return {
    tag: SEARCH_REQUEST,
    query: query,
    filters: filters,
    sort: sort,
    page: page
  };
};
var SearchModel = {
  id: "search",
  init: function init(_ref) {
    var query = _ref.query,
      location = _ref.location,
      incVat = _ref.incVat;
    return updateData({
      state: "LOADING",
      query: query
    }, search(query, location, incVat));
  },
  update: function update(state, msg) {
    switch (msg.tag) {
      case EFFECT_ERROR:
        throw new Error("Route load failed");
      case SEARCH_REQUEST:
        if (state.state === "LOADED") {
          return updateData({
            state: "UPDATING",
            query: msg.query,
            data: state.data
          }, msg);
        }
        break;
      case SEARCH_RESPONSE:
        if (msg.data && (state.state === "LOADING" || state.state === "UPDATING")) {
          return updateData({
            state: "LOADED",
            query: state.query,
            data: msg.data
          });
        }
        throw new Error("Failed to fetch search results");
      default:
    }
  }
};

export { SEARCH_REQUEST, SEARCH_RESPONSE, SearchModel, search };
//# sourceMappingURL=index.esm.js.map
